// extracted by mini-css-extract-plugin
export default {"card":"QuestionCard_card__EgLUb","questionText":"QuestionCard_questionText__gRt17","questionImage":"QuestionCard_questionImage__e4FNu"};